/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { CountyVoModel } from '@well/common-libs/country-management/domain-model';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({
  providedIn: 'root',
})
export class CountyVoResourceService extends SelectableResourceService<CountyVoModel> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient, `${environmentService.getEnvironmentProperty('countyUrl')}/vos`, CountyVoModel);
  }
}
